module.exports = __webpack_public_path__ + "img/tech_4.cbb7b805.jpg";